export const categories = [
  {
    id: 1,
    name: "Potato",
    items: 10,
  },
  {
    id: 2,
    name: "Tomato",
    items: 76,
  },
  {
    id: 3,
    name: "Pepper",
    items: 52,
  },
  {
    id: 4,
    name: "Ingredients",
    items: 38,
  },
];

export const products = [
  {
    id: 1,
    name: "Potato",
    thumbnail: "potato.jpg",
    createdDateTime: "1659756670",
    updatedDateTime: "1655058865",
  },
  {
    id: 2,
    name: "Tomato",
    thumbnail: "tomato.jpg",
    createdDateTime: "1640076944",
    updatedDateTime: "1641951868",
  },
  {
    id: 3,
    name: "Pepper",
    thumbnail: "pepper.jpg",
    createdDateTime: "1655010548",
    updatedDateTime: "1630483517",
  },
  {
    id: 4,
    name: "Ingredients",
    thumbnail: "ingredients.jpg",
    createdDateTime: "1635580930",
    updatedDateTime: "1655662199",
  },
  {
    id: 5,
    name: "Garlic",
    thumbnail: "garlic.jpg",
    createdDateTime: "1651105915",
    updatedDateTime: "1653783049",
  },
  {
    id: 6,
    name: "Breakfast",
    thumbnail: "breakfast.jpg",
    createdDateTime: "1632515855",
    updatedDateTime: "1652253810",
  },
  {
    id: 7,
    name: "Onion",
    thumbnail: "onion.jpg",
    createdDateTime: "1653605654",
    updatedDateTime: "1645037229",
  },
  {
    id: 8,
    name: "Pepper Flower",
    thumbnail: "pepper-flower.jpg",
    createdDateTime: "1645811838",
    updatedDateTime: "1655894442",
  },
  {
    id: 9,
    name: "Potato",
    thumbnail: "potato.jpg",
    createdDateTime: "1630005280",
    updatedDateTime: "1632678752",
  },
  {
    id: 10,
    name: "Tomato",
    thumbnail: "tomato.jpg",
    createdDateTime: "1640911588",
    updatedDateTime: "1641440283",
  },
];
